<template>
  <v-container pa-0>
    <v-dialog v-model="showDialog" max-width="750" @input="v => v || closing()">
      <v-card v-if="full === false">
        <v-card-text class="confirm-dialog-card-text">
          <slot></slot>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn :color="confirmBtnColor" v-if="confirmBtnText !== ''" @click="hiding(true)" :disabled="confirmBtnDisalbed">
            {{ $vuetify.t(confirmBtnText) }}
          </v-btn>
          <v-btn :color="cancelBtnColor" @click="hiding(false)">
            {{ $vuetify.t(cancelBtnText) }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="full">
        <slot></slot>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  export default {
    name: 'ConfirmDialog',
    data: function () {
      return {
        showDialog: false
      }
    },
    props: {
      confirmBtnColor: {
        type: String,
        default: null
      },
      confirmBtnText: {
        type: String,
        default: '$vuetify.Form.ok'
      },
      confirmBtnDisalbed: {
        type: Boolean,
        default: false
      },
      cancelBtnColor: {
        type: String,
        default: null
      },
      cancelBtnText: {
        type: String,
        default: '$vuetify.Form.cancel'
      },
      full: {
        type: Boolean,
        default: false
      },
      show: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      show: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal) {
            this.showing()
          } else {
            if (this.full) {
              this.showDialog = false
            }
          }
        }
      }
    },
    methods: {
      closing () {
        this.hiding(false)
      },
      showing () {
        this.showDialog = true
      },
      hiding (confirmed) {
        if (confirmed) {
          this.$emit('confirmed')
        } else {
          this.$emit('closed')
        }
        this.showDialog = false
      }
    }
  }
</script>
